export default "__VITE_ASSET__D2NzP4qQ__"